<template>
    <div class="mt-4 bg-white mx-4">
        <div class="row justify-content-center mt-5 card">
            <div class="card-header text-primary">Create Sub Admin</div>
            <div class="col-md-8 col-sm-12 card-body offset-2">
                <div class="alert alert-info " v-if="success">
                    <p>Sub-Admin's <b>login details</b> was sent to {{formInfo.email}}</p>
                    <button @click="showInputs()" class="btn btn-info btn-sm">Create Another Sub-admin</button>
                </div>
                <div class="mt-5" v-if="!success">
                    <form action="#" @submit.prevent>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> First Name</label>
                                <input class="form-control" type="text" placeholder="Enter First name" v-model.trim="$v.formInfo.firstName.$model"  :class="{'is-invalid':$v.formInfo.firstName.$error, 'is-valid':!$v.formInfo.firstName.$invalid}">
                            </div>
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span>Last Name</label>
                                <input class="form-control" type="text"  placeholder="Enter Last name" v-model.trim="$v.formInfo.lastName.$model"  :class="{'is-invalid':$v.formInfo.lastName.$error, 'is-valid':!$v.formInfo.lastName.$invalid}">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Email</label>
                                <input class="form-control" type="email" placeholder="Enter your Email" v-model.trim="$v.formInfo.email.$model"  :class="{'is-invalid':$v.formInfo.email.$error, 'is-valid':!$v.formInfo.email.$invalid}">
                            </div>
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Phone Number</label>
                                <input class="form-control" type="text"  placeholder="Enter your phone" v-model.trim="$v.formInfo.phone.$model"  :class="{'is-invalid':$v.formInfo.phone.$error, 'is-valid':!$v.formInfo.phone.$invalid}">
                            </div>
                        </div>

                        <div class="form-group mb-3 mt-4 text-center" v-if="!sending">
                            <button class="btn btn-primary btn-sm px-5" :disabled="$v.formInfo.$invalid || hasVoted == 'true'" type="submit" @click.prevent="createSubAdmin()"> Create Sub Admin </button>
                            </div>
                            <div class="form-group mb-3 text-center px-5" v-if="sending">
                            <button class="btn btn-primary btn-sm" disabled type="submit" > Create Sub Admin </button>
                        </div>

                    </form>
                </div>
            </div> <!-- end col -->
        </div>

    </div>
</template>

<script>
import { required, email, minLength} from 'vuelidate/lib/validators'
import { mapState } from 'vuex';

export default {
    name: 'CreateSUbAdmin',
    data() {
        return {
            formInfo: {
                email: null,
                phone: null,
                firstName: null,
                lastName: null,
            },
            allstates: [],
            sending:false,
            hasVoted:false,
            success:false,
        };
    },
    validations: {
        formInfo: {
            email: { required, email },
            phone:{ required, minLength: minLength(9) },
            firstName:{ required },
            lastName:{ required },
        }
    },

    computed:{
        ...mapState(['token'])
    },

    methods:{
        showInputs(){
            this.success = !this.success // display inputs

            // clear the input fields
            for (const input in this.formInfo) {
                if (this.formInfo.hasOwnProperty(input)) {
                    this.formInfo[input] = ''
                }
            }
        },


        createSubAdmin(){
            // Only send after validations
            this.$v.formInfo.$touch()
            if (this.$v.formInfo.$invalid || this.$v.formInfo.$error) {
                this.$toastr.e("Fill in the forms correctly");
            } else {
                // submit logic
                const baseU = `${this.$urlAuth}/createsubadmin`;

                this.$http.post(baseU, this.formInfo, {
                    headers:{
                        "x-access-token":this.token
                    }
                })
                .then((result) => {
                    if(result.data.data.code == "S201"){
                        // console.log(result)
                        this.$toastr.s("Account Created Succesfully");

                        this.success = true;

                    }else if(result.data.data.code == "E301"){
                        this.$toastr.e(result.data.data.message[0], 'Error message');
                    }else if(result.data.data.code == "E200"){
                        this.$toastr.e(result.data.data.message, 'Error message');
                    }else{
                        this.$toastr.e("Unexpected Error. Please contact Admin");
                    }
                }).catch(err =>{
                    this.$toastr.e("Cannot connect to server. Check your internet connection");
                })
            }
        }
    }
}

</script>